import { useState } from 'react';
import { UnidataUrlData } from '../../libs/controls/Grid/interfaces';
import { buildUrl, getUrlParamsEntries } from '../../libs/helpers/Utils';
import { mapUrlOptions } from '../utils/mapUrlOptions';

interface Props {
  api: any;
  data: UnidataUrlData;
  urlParams: {
    [p: string]: string;
  };
}

export const useGetOptionsByData = ({ data, api, urlParams }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState<UnidataUrlData['extra'][]>([]);

  const getOptions = () => {
    let _urlParams = '';

    // мапим нужные части ctrl.dataMapped
    const dataMapped = !!data ? { ...data } : undefined;
    if (!!dataMapped && !!dataMapped.url) {
      dataMapped.url = buildUrl(dataMapped?.url, api.options);
    }

    if (dataMapped?.urlParams && urlParams) {
      _urlParams = getUrlParamsEntries(dataMapped, urlParams);
    }

    if (dataMapped?.url) {
      setIsLoading(true);

      if (!api.options.baseUrl) {
        new Error('Исправьте конфигурацию, не добавлен baseUrl');
      }

      api?.moduleApi?.get(
        `${api.options.baseUrl}${dataMapped.url}${_urlParams}`,
        dataMapped?.query || null,
        {
          success: (response) => {
            const options = mapUrlOptions(response.data, dataMapped?.extra);

            console.log(response);

            setOptions(options);
            setIsLoading(false);
          },
          error: () => {
            setIsLoading(false);
          },
        },
      );
    }
  };

  return { isLoading, options, getOptions };
};
